import Header from './components/Header';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import AboutSection from './components/AboutSection';
import FeaturesSection from './components/FeaturesSection';
import ArticleSection from './components/ArticleSection';
import Footer from './components/Footer';
import { HomeSchema } from '@/components/feature/SeoSchema';

export default function Home() {
  return (
    <main className="min-h-screen">
      <Header />
      <HomeSchema />
      <Hero />
      <CategoryGrid />
      <AboutSection />
      <FeaturesSection />
      <ArticleSection />
      <Footer />
    </main>
  );
}